import { Id } from "./id";

type WeekTimeRecord = {
  uuid: Id;
  recordingDate: string;
  timeSpent: number;
  attributes: { [key: string]: string };
  resource: { uuid: Id; name: string; integratedAt?: string };
  task: { uuid: Id; name: string };
  project: { uuid: Id; name: string; integratedAt?: string };
  zone: { uuid: Id; name: string; color: string };
};

type WeekTimeRecordsScope =
  | { resourceUuid: Id }
  | { managerUuid: Id }
  | { projectUuid: Id };

export type { WeekTimeRecord, WeekTimeRecordsScope };
